import { render } from "./QuestionnairePage.vue?vue&type=template&id=88a39b3c&scoped=true"
import script from "./QuestionnairePage.vue?vue&type=script&lang=js"
export * from "./QuestionnairePage.vue?vue&type=script&lang=js"

import "./QuestionnairePage.vue?vue&type=style&index=0&id=88a39b3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a39b3c"]])

export default __exports__